import { render, staticRenderFns } from "./TaxesTableHeader.vue?vue&type=template&id=665677c6&"
import script from "./TaxesTableHeader.vue?vue&type=script&lang=ts&"
export * from "./TaxesTableHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports